import React from 'react';
import { Modal, Spin, Progress, Typography } from 'antd';
import Control from 'components/Control/Control';

/**
 * Simple centered modal that shows CV parsing progress.
 * - If `progress` is 0 (or 100) we just show a spinner.
 * - For any intermediate value we render an AntD circular Progress.
 */
const CvProgressModal = ({ visible, progress = 0 }) => (
  <Modal
    visible={visible}
    footer={null}
    closable={false}
    maskClosable={false}
    centered
    width="80%"
    bodyStyle={{
      padding: '0',
      textAlign: 'center',
      borderRadius: '10px',
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden'
    }}
  >
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
      padding: '20px'
    }}>
      <Control center column gap="20px">
        <Progress percent={progress} type="circle" width={120} />
        <div style={{ marginTop: '20px' }}>
          <Typography.Title level={3} style={{ margin: 0, color: '#4D566E' }}>
            CV Parsing in Progress
          </Typography.Title>
          <Typography.Text style={{ fontSize: '16px', color: '#4D566E' }}>
            Please wait while we analyze your CV to pre-fill your profile information.
          </Typography.Text>
        </div>
      </Control>
    </div>
  </Modal>
);

export default CvProgressModal;
